import { useEffect, useRef } from 'react';



import { usePusherContext } from '@common/contexts/Pusher';
import { STORAGE_KEYS } from '@constants/storageKeys';


interface UseDevicePusherProps {
    crmId?: number;
    onIncomingModal?: (payload: any) => void;
    onIncomingCall?: (payload: any) => void;
    onCallSettingsChange?: (payload: any) => void;
}

export const useDevicePusher = ({
    crmId = 1,
    onIncomingModal,
    onIncomingCall,
    onCallSettingsChange,
}: UseDevicePusherProps) => {
    const { pusher, subscribeToChannel } = usePusherContext();
    const isSubscribedRef = useRef(false);
    const deviceChannelRef = useRef<any>(null);
    const callSettingChannelRef = useRef<any>(null);
    const callbacksRef = useRef({ onIncomingModal, onIncomingCall, onCallSettingsChange });

    // Обновляем колбэки в ref без перезапуска эффекта
    useEffect(() => {
        callbacksRef.current = { onIncomingModal, onIncomingCall, onCallSettingsChange };
    }, [onIncomingModal, onIncomingCall, onCallSettingsChange]);

    useEffect(() => {
        // console.log("🚀 ~ useDevicePusher ~ crmId:", crmId);
        console.log("🚀 ~ useDevicePusher ~ pusher:", pusher);

        // if (!crmId) return undefined;

        // Проверяем, инициализирован ли Pusher
        if (!pusher) {
            console.log('⏳ Ожидание инициализации Pusher...');
            return undefined;
        }

        const deviceId = localStorage.getItem(STORAGE_KEYS.DEVICE_ID);

        if (!deviceId) {
            console.warn('device_unique_id не найден в localStorage');
            return undefined;
        }

        // Проверяем, подписан ли уже канал в Pusher
        const deviceChannelName = `private-device.${deviceId}`;
        const callSettingChannelName = `private-call-setting.all`;
        
        const existingDeviceChannel = pusher.channel(deviceChannelName);
        const existingCallSettingChannel = pusher.channel(callSettingChannelName);

        // Если каналы уже подписаны и мы уже инициализировали обработчики, не подписываемся повторно
        if (isSubscribedRef.current && existingDeviceChannel && existingCallSettingChannel) {
            console.log('✅ Каналы уже подписаны, пропускаем повторную подписку');
            return undefined;
        }

        // Отписываемся от старых каналов, если они есть
        if (deviceChannelRef.current) {
            deviceChannelRef.current.unbind_all();
            deviceChannelRef.current.unsubscribe();
        }
        if (callSettingChannelRef.current) {
            callSettingChannelRef.current.unbind_all();
            callSettingChannelRef.current.unsubscribe();
        }

        const deviceChannel = subscribeToChannel(deviceChannelName);
        console.log("🚀 ~ useDevicePusher ~ deviceChannel:", deviceChannel);
        const callSettingChannel = subscribeToChannel(callSettingChannelName);

        if (!deviceChannel || !callSettingChannel) {
            console.error('Ошибка: Не удалось подписаться на каналы Pusher');
            return undefined;
        }

        // Сохраняем ссылки на каналы
        deviceChannelRef.current = deviceChannel;
        callSettingChannelRef.current = callSettingChannel;
        isSubscribedRef.current = true;

        // const handleModal = (data: any) => {
        //     console.log('Модалка для девайса', deviceId, data);
        //     callbacksRef.current.onIncomingModal?.(data);
        // };

        const handleCall = (data: any) => {
            console.log('Входящий звонок для девайса', deviceId, data);
            callbacksRef.current.onIncomingCall?.(data);
        };

        const handleCallSettings = (data: any) => {
            console.log('Настройки звонков изменены для CRM', data);
            callbacksRef.current.onCallSettingsChange?.(data);
        };

        // TODO: заменить имена событий на реальные, когда бек будет готов
        // deviceChannel.bind('device.modal', handleModal);
        deviceChannel.bind('incoming-call', handleCall);
        callSettingChannel.bind('call-setting.updated', handleCallSettings);

        deviceChannel.bind('pusher:subscription_succeeded', () => {
            console.log(`✅ Подписка на private-device.${deviceId} успешна`);
        });

        callSettingChannel.bind('pusher:subscription_succeeded', () => {
            console.log(`✅ Подписка на private-call-setting.all успешна`);
        });

        return () => {
            // deviceChannel.unbind('device.modal', handleModal);
            deviceChannel.unbind('incoming-call', handleCall);
            callSettingChannel.unbind('call-setting.updated', handleCallSettings);

            deviceChannel.unbind_all();
            callSettingChannel.unbind_all();

            deviceChannel.unsubscribe();
            callSettingChannel.unsubscribe();

            // Сбрасываем флаг подписки при размонтировании
            isSubscribedRef.current = false;
            deviceChannelRef.current = null;
            callSettingChannelRef.current = null;
        };
    }, [pusher, subscribeToChannel]);
};